var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.8,
    transform: "rotate(-90 12 12)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.629 7.25921C11.8558 7.35912 12 7.56934 12 7.79999V16.2C12 16.4306 11.8558 16.6408 11.629 16.7408C11.4022 16.8407 11.133 16.8126 10.9366 16.6685L7.84313 14.4H5.45455C5.09305 14.4 4.8 14.1314 4.8 13.8V10.2C4.8 9.86861 5.09305 9.59998 5.45455 9.59998H7.84313L10.9366 7.33147C11.133 7.18738 11.4022 7.15929 11.629 7.25921ZM10.6909 9.04836L8.48162 10.6685C8.36556 10.7536 8.22136 10.8 8.07273 10.8H6.10909V13.2H8.07273C8.22136 13.2 8.36556 13.2463 8.48162 13.3315L10.6909 14.9516V9.04836Z",
    fill: "#4C505E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8358 9.79324C14.0827 9.54635 14.483 9.54635 14.7298 9.79324L18.7531 13.8165C19 14.0634 19 14.4636 18.7531 14.7105C18.5062 14.9574 18.1059 14.9574 17.859 14.7105L13.8358 10.6873C13.5889 10.4404 13.5889 10.0401 13.8358 9.79324Z",
    fill: "#4C505E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8357 14.7104C13.5888 14.4636 13.5888 14.0633 13.8357 13.8164L17.859 9.79315C18.1059 9.54627 18.5061 9.54627 18.753 9.79315C18.9999 10.04 18.9999 10.4403 18.753 10.6872L14.7298 14.7104C14.4829 14.9573 14.0826 14.9573 13.8357 14.7104Z",
    fill: "#4C505E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.2f873bef7525cfc882baf04bad730d03.svg";
export { ForwardRef as ReactComponent };